import { render, staticRenderFns } from "./NewListItem.vue?vue&type=template&id=46b2f2a4"
import script from "./NewListItem.vue?vue&type=script&lang=ts"
export * from "./NewListItem.vue?vue&type=script&lang=ts"
import style0 from "./NewListItem.vue?vue&type=style&index=0&id=46b2f2a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports